import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { docDongY, ghiDongY, theoDoiDongY } from '../lib/consent.js';
import { DO_LUONG_BAT, CAU_HINH_DO_LUONG } from '../lib/track.js';

/**
 * Banner xin đồng ý đo lường. Chỉ dựng trên trình duyệt (không có trong HTML
 * prerender) để không lệch khi hydrate và không che nội dung với Googlebot.
 *
 * Hai nút ngang hàng, cùng kích thước: từ chối phải dễ như đồng ý.
 */
export default function DongYCookie() {
  const [hien, setHien] = useState(false);
  const [moLai, setMoLai] = useState(false);
  const [hienTai, setHienTai] = useState(null);

  useEffect(() => {
    if (!DO_LUONG_BAT) return undefined;
    const c = docDongY();
    setHienTai(c);
    if (!c) setHien(true);
    return theoDoiDongY((d) => {
      if (d.moLai) { setHienTai(docDongY()); setMoLai(true); setHien(true); }
      if (d.chon) { setHienTai(d.chon); setHien(false); setMoLai(false); }
    });
  }, []);

  if (!DO_LUONG_BAT || !hien) return null;

  const congCu = [CAU_HINH_DO_LUONG.ga && 'Google Analytics', CAU_HINH_DO_LUONG.clarity && 'Microsoft Clarity'].filter(Boolean).join(' và ');

  return (
    <div className="dong-y-cookie" role="dialog" aria-live="polite" aria-labelledby="dong-y-tieu-de">
      <div className="dong-y-noi-dung">
        <p id="dong-y-tieu-de" className="dong-y-tieu-de">Cho phép đo lường ẩn danh?</p>
        <p>
          Để biết công cụ và bài viết nào hữu ích, chúng tôi muốn dùng {congCu} ghi nhận trang bạn
          xem và thao tác như mở công cụ hay tải mẫu. Số liệu bạn nhập, tên công ty và email không
          được gửi đi. Từ chối thì website vẫn dùng đầy đủ.{' '}
          <Link to="/quyen-rieng-tu#cookie-va-do-luong">Chi tiết</Link>
        </p>
        {moLai && hienTai && <p className="nho">Lựa chọn hiện tại: <strong>{hienTai === 'dong-y' ? 'Đã đồng ý' : 'Đã từ chối'}</strong>.</p>}
      </div>
      <div className="dong-y-nut">
        <button type="button" className="nut phu" onClick={() => ghiDongY('tu-choi')}>Từ chối</button>
        <button type="button" className="nut" onClick={() => ghiDongY('dong-y')}>Đồng ý</button>
        {moLai && <button type="button" className="text-button" onClick={() => { setHien(false); setMoLai(false); }}>Đóng</button>}
      </div>
    </div>
  );
}
